import { storage, gotoLogin, getAuthToken } from './utils';

angular.module('app.auth').config(($httpProvider) => {
  'ngInject';
  $httpProvider.interceptors.push(($q, $window, $injector) => {
    return {
      request: (config) => {
        let token = getAuthToken();
        if (!token) {
          gotoLogin('from interceptor missing token');
        }

        if (config.url.startsWith('http://localhost:3000')) {
          config.headers['Authorization'] = `Bearer user`;
        } else if (
          config.headers['Ignore-Http-Interceptor-Auth'] ||
          config.url.match('^https?://.*s3.amazonaws.com/.*')
        ) {
          // Some requests need to be in public scope, use this header
          // to indiciate request to ignore the auto-injection
        } else {
          config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
      },
      responseError: (rejection) => {
        if (rejection.status == 401 && rejection.data && rejection.data.error == 'invalid_token') {
          gotoLogin('from interceptor 401');
        }
        return $q.reject(rejection);
      },
    };
  });
});



// WEBPACK FOOTER //
// ./app/auth/auth-interceptor.js